import { gql, NetworkStatus, useMutation, useQuery } from '@apollo/client'
import { useMemo } from 'react'

import {
  ArtistCategoryDetailQuery,
  ArtistCategoryDetailQueryVariables,
  ArtistCreatePostCategoryInput,
  ArtistRemovePostCategoryInput,
  ArtistUpdatePostCategoryInput,
  CreatePostCategoryMutation,
  DeletePostCategoryMutation,
  MutationArtistCreatePostCategoryArgs,
  MutationArtistRemovePostCategoryArgs,
  MutationArtistUpdatePostCategoryArgs,
  UpdatePostCategoryMutation,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()

  const { data, networkStatus } = useQuery<
    ArtistCategoryDetailQuery,
    ArtistCategoryDetailQueryVariables
  >(QUERY)

  const [createPostCategory] = useMutation<
    CreatePostCategoryMutation,
    MutationArtistCreatePostCategoryArgs
  >(CREATE_POST_CATEGORY, {
    refetchQueries: () => [{ query: QUERY }],
    awaitRefetchQueries: true,
  })

  const [updatePostCategory] = useMutation<
    UpdatePostCategoryMutation,
    MutationArtistUpdatePostCategoryArgs
  >(UPDATE_POST_CATEGORY, {
    refetchQueries: () => [{ query: QUERY }],
    awaitRefetchQueries: true,
  })

  const [deletePostCategory] = useMutation<
    DeletePostCategoryMutation,
    MutationArtistRemovePostCategoryArgs
  >(Delete_POST_CATEGORY, {
    refetchQueries: () => [{ query: QUERY }],
    awaitRefetchQueries: true,
  })

  const categories = useMemo(() => {
    if (data?.artist?.postCategory?.categories.length) {
      return data?.artist?.postCategory?.categories
    }
    return []
  }, [data?.artist?.postCategory?.categories])

  return {
    state: {
      artistId: user?.uid ?? '',
      categories: categories,
      loading: networkStatus === NetworkStatus.loading,
    },
    actions: {
      onCreateCategory: async (inputs: ArtistCreatePostCategoryInput) => {
        await createPostCategory({
          variables: {
            inputs: {
              ...inputs,
            },
          },
        })
        return
      },
      onUpdateCategory: async (inputs: ArtistUpdatePostCategoryInput) => {
        await updatePostCategory({
          variables: {
            inputs: {
              ...inputs,
            },
          },
        })
        return
      },
      onDeleteCategory: async (inputs: ArtistRemovePostCategoryInput) => {
        await deletePostCategory({
          variables: {
            inputs: {
              ...inputs,
            },
          },
        })
        return
      },
    },
  }
})

const QUERY = gql`
  query artistCategoryDetail {
    artist {
      id
      postCategory {
        categories {
          id
          name
          description
          createdAt
          updatedAt
        }
      }
    }
  }
`
const CREATE_POST_CATEGORY = gql`
  mutation CreatePostCategory($inputs: ArtistCreatePostCategoryInput!) {
    artistCreatePostCategory(inputs: $inputs) {
      categories {
        id
      }
    }
  }
`

const UPDATE_POST_CATEGORY = gql`
  mutation UpdatePostCategory($inputs: ArtistUpdatePostCategoryInput!) {
    artistUpdatePostCategory(inputs: $inputs) {
      categories {
        id
      }
    }
  }
`
const Delete_POST_CATEGORY = gql`
  mutation DeletePostCategory($inputs: ArtistRemovePostCategoryInput!) {
    artistRemovePostCategory(inputs: $inputs) {
      categories {
        id
      }
    }
  }
`
